import $ from "jquery";
/**样式 */
import "../style/index.scss";
import "../../../public/style/common_header.scss";
import "../../../public/style/common_footer.scss";
import "../../../../node_modules/swiper/swiper-bundle.min.css";
/**头部导航 */
import "../../../public/ts/header_nav";
var _window = window;
/**轮播图 */
function banner() {
    new _window.Swiper($(".banner .swiper")[0], {
        autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
        loop: true,
        observeParents: true,
        pagination: {
            el: $(".banner .swiper-pagination")[0],
        },
    });
}
banner();
/**新闻 */
function news() {
    var pagination = $(".news_container .swiper-pagination")[0];
    var data_text = $(".data_text")[0];
    new _window.Swiper($(".news_container .swiper")[0], {
        autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
        loop: true,
        observeParents: true,
        pagination: {
            el: pagination,
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            }
        },
        on: {
            slideChange: function () {
                var _this = this;
                var activeEle = $(_this.wrapperEl)[0].children[_this.activeIndex];
                var text = activeEle.dataset.text;
                data_text.innerHTML = text || "";
            }
        }
    });
}
news();
/**成功案例, 合作单位 */
function cooperation() {
    new _window.Swiper($(".ser_case .swiper")[0], {
        autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 10,
    });
    new _window.Swiper($(".cooperation .swiper")[0], {
        autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
        loop: true,
        direction: 'vertical',
        slidesPerView: 'auto',
        loopedSlides: 10,
    });
}
cooperation();
